import React, { useMemo } from 'react';
import { Select } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';

import { getLastNYears } from 'Utils';
import { DATE_RANGES_TYPES } from 'Common/enums';
import styles from './DateRange.css';
import SubFields from './SubFields';

type Props = {
    dateRangeObj: DateRangeObject;
    setDateRangeObj: (dateRange: DateRangeObject) => void;
    dateRangeErrors?: DateRangeError;
};

const DateRange = ({ dateRangeObj, setDateRangeObj, dateRangeErrors }: Props) => {
    const { t } = useTranslation();
    const last10YearsOptions = useMemo(() => getLastNYears(10), []);
    const updateDateRangeType = (type: valueof<typeof DATE_RANGES_TYPES>) => {
        setDateRangeObj({
            dateRangeType: type,
            dateRangeValue: null,
            dateRangeMinValue: dateRangeObj.dateRangeMinValue,
            isOutOfMinRange: dateRangeObj.isOutOfMinRange
        });
    };

    const updateDateRangeValue = (value: DateRangeValue) => {
        setDateRangeObj({
            ...dateRangeObj,
            dateRangeValue: value
        });
    };

    const { dateRangeType } = dateRangeObj;
    return (
        <div className={styles.dateRangeContainer}>
            <Select
                dataTestId='date-range-type-select'
                className={styles.dateRangeTypeSelect}
                label={t('Date Range')}
                inlineLabel
                size='sm'
                placeholder='-Select-'
                selectedItems={[dateRangeType]}
                handleClickCallback={(value) => updateDateRangeType(value[0])}
            >
                <option value={DATE_RANGES_TYPES.CUSTOM}>{t('Custom')}</option>
                <option value={DATE_RANGES_TYPES.PAST_DAYS}>{t('Past Days')}</option>
                <option value={DATE_RANGES_TYPES.MONTH}>{t('Month')}</option>
                <option value={DATE_RANGES_TYPES.YEAR}>{t('Year')}</option>
                <option value={DATE_RANGES_TYPES.MONTH_TO_DATE}>{t('Month to Date')}</option>
                <option value={DATE_RANGES_TYPES.YEAR_TO_DATE}>{t('Year to Date')}</option>
            </Select>
            <SubFields
                dateRangeValueErrs={dateRangeErrors?.dateRangeValue}
                yearsOptions={last10YearsOptions}
                dateRangeObj={dateRangeObj}
                updateDateRangeValue={updateDateRangeValue}
            />
        </div>
    );
};

export default DateRange;
